
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13315',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13315",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.890",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.9999",
  "foundations-components": "static-1.8562",
  "foundations-components-legacy": "static-1.1587",
  "foundations-theming": "static-1.4825",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.90",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8384",
  "hub-http-shared-msw-handlers": "static-1.10696",
  "hubspot-dlb": "static-2.1905",
  "hubspot-url-utils": "static-1.4366",
  "HubStyleTokens": "static-2.11839",
  "I18n": "static-7.1680",
  "jasmine-runner": "static-1.6798",
  "marketplace-discovery-studio-lib": "static-1.711",
  "marketplace-storefront-base": "static-1.13378",
  "quartz": "static-1.7513",
  "react-dlb": "static-1.89",
  "react-rhumb": "static-1-fkhalid-rhumb-pageload-totimings.2",
  "reactive-variable-buffer-atom": "static-1.3202",
  "reporting-testing-lib": "static-1.10891",
  "reselect": "static-3.13",
  "settings-ui-lib": "static-1.12872",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7688",
  "ui-addon-i18n": "static-1.11495",
  "ui-addon-react-router-dom": "static-1.9881",
  "unified-auth": "static-1.1000",
  "unified-auth-core-lib": "static-1.1282",
  "usage-tracker": "static-1.7661",
  "usage-tracker-core": "static-1.7511",
  "customer-data-property-utils": "static-1.8445",
  "hub-http": "static-1.6560",
  "integrations-lib": "static-1.17159",
  "marketplace-ui-common": "static-1.20821",
  "marketplace-ui-install": "static-1.807",
  "property-management-iframe": "static-1.14220",
  "quartz-config": "static-1.1291",
  "quartz-core": "static-1.6732",
  "quartz-routing": "static-1.943",
  "quick-fetch": "static-1.4159",
  "react": "static-7.196",
  "rpc-client-utils": "static-1.5014",
  "ts-schema": "static-1.4325",
  "ui-universal-auth": "static-1.9486",
  "UIComponents": "static-3.8785",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.87",
  "metrics-js": "static-1.9963",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3790",
  "quartz-webpack": "static-1.3737",
  "bend-plugin-quartz-routing": "static-1.591",
  "ai-components-ui-library": "static-1.9809",
  "codemirror": "static-5.103",
  "foundations-assets": "static-1.5234",
  "pulse": "static-1.978",
  "react-codemirror": "static-1.10991",
  "ui-extensions-preview-lib": "static-1.695",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4831",
  "floating-ui": "static-1.64",
  "foundations-theming-specialty": "static-1.2541",
  "framer-motion": "static-1.80",
  "hs-story-utils": "static-1.9772",
  "react-aria": "static-1.73",
  "react-create-root-preference": "static-1.79",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5587",
  "react-virtualized": "static-2.108",
  "StyleGuideUI": "static-3.508",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2752",
  "ui-fonts": "static-1.1101",
  "ui-images": "static-2.1265",
  "bend-plugin-foundations-theming": "static-1.3308",
  "foundations-theming-base": "static-1.3810",
  "stylex": "static-1.42",
  "HeadJS": "static-2.804",
  "hs-test-utils-bend-plugin": "static-1.3495",
  "msw": "static-1.39",
  "testing-library": "static-1.159",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4660",
  "ui-addon-video-player": "static-1.9049",
  "ai-rendering-library": "static-1.11187",
  "chirp-fetch": "static-1.2245",
  "connections-embed-lib": "static-1.1575",
  "copilot-toolkit": "static-1.11926",
  "feedback-loader": "static-1.29874",
  "laboratory-lib": "static-3.7501",
  "marketplace-embed": "static-1.22999",
  "marketplace-ui-details": "static-1.10716",
  "marketplace-ui-reviews": "static-1.20776",
  "marketplace-ui-tracking": "static-1.14991",
  "sanitize-text": "static-1.8505",
  "usage-tracker-multi": "static-1.6075",
  "usage-tracker-session-replay": "static-1.5347",
  "wootric-nps": "static-1.7232",
  "quartz-head": "static-1.1178",
  "web-vitals": "static-1.16",
  "apollo-link-hub-http": "static-2.5004",
  "immer": "static-1.102",
  "immerable": "static-1.4493",
  "highcharts": "static-8.112",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2720",
  "reporting-data": "static-1.68958",
  "cssUtils": "static-1.971",
  "flux-actions": "static-1.374",
  "react-colorpicker": "static-2.10562",
  "react-dnd-compat": "static-1.4964",
  "redux-observable": "static-1.76",
  "ReduxMessenger": "static-2.10719",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7651",
  "icons": "static-2.695",
  "marketplace-ui-apps-core": "static-1.19353",
  "storybook-react": "static-1.41",
  "trellis-story-utils": "static-1.4855",
  "foundations-components-test-utils": "static-1.6045",
  "quartz-i18n": "static-1.1188",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.549",
  "ads-unified-auth-lib": "static-1.1526",
  "custom-vendor-connection-lib": "static-1.50",
  "google-sheets-integration-lib": "static-1.1113",
  "microsoft-drive-auth-lib": "static-1.240",
  "surveymonkey-integration-lib": "static-1.582",
  "slack-ui-library": "static-1.10746",
  "fsm": "static-1.4100",
  "customer-data-objects": "static-1.8047",
  "property-translator": "static-1.5740",
  "hs-locale-management": "static-1.326",
  "frontend-preferences-client": "static-1.8267",
  "hs-promise-utils": "static-1.5938",
  "hubspot-apollo-client": "static-1.5224",
  "integrations-error-boundary-lib": "static-1.14575",
  "integrations-tracking-lib": "static-1.5958",
  "native-integrations-shared-strings": "static-1.8124",
  "sanitize": "static-1.4820",
  "superstore": "static-1.5108",
  "ui-shepherd-react": "static-3.10619",
  "ai-settings-ui-library": "static-1.8406",
  "hub-http-janus": "static-1.888",
  "hubspotter-http": "static-1.4895",
  "immutable-less": "static-1.4999",
  "marketplace-ui-client-types": "static-1.18228",
  "nav-meta": "static-1.30553",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18439",
  "ui-product-approvals-common": "static-1.1202",
  "ai-studio-lib": "static-1.12511",
  "hubspot-prosemirror": "static-1.19064",
  "integrations-reconnect-lib": "static-1.548",
  "ui-addon-iframeable": "static-1.9425",
  "ui-addon-integrations-directory-panel": "static-2.8374",
  "ui-product-approvals": "static-1.29307",
  "ui-tool-access": "static-1.10503",
  "inbound-db-properties-service-client": "static-1.4079",
  "property-management-common": "static-1.6508",
  "opentelemetry-fe-types": "static-1.126",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.584",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.501",
  "quartz-auth": "static-1.1188",
  "quartz-test": "static-1.1188",
  "quartz-tracking": "static-1.892",
  "trellis-components": "static-1.2771",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.424",
  "HubStyle": "static-2.12146",
  "bender-build-tools": "static-1.3452",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23233",
  "ContentUtils": "static-1.69213",
  "customer-data-objects-ui-components": "static-1.13379",
  "sassPrefix": "static-1.237",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.481",
  "batch-promise": "static-1.1893",
  "event-emitter": "static-1.1305",
  "fast-json-patch": "static-1.71",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5789",
  "magpie-types": "static-1.5249",
  "stylex-utils": "static-1.148",
  "trellis-theming": "static-1.1322",
  "avatar-components": "static-1.2832",
  "breeze-engine-core": "static-1.1139",
  "breeze-onboarding-components": "static-1.819",
  "customer-data-filters-ui": "static-1.41050",
  "customer-data-reference-ui-components": "static-1.13526",
  "embedded-academy-lib": "static-1.15666",
  "ExportDialog": "static-6.10727",
  "global-styles-ai-lib": "static-1.232",
  "highlight.js": "static-1.87",
  "marketplace-embed-ba": "static-1.702",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42147",
  "reporting-snowflake": "static-1.57574",
  "reporting-ui-components": "static-2.66227",
  "reporting-visualizations": "static-1.61032",
  "trial-components-library": "static-1.14182",
  "ui-addon-teams": "static-1.21959",
  "upgrade-components-lib": "static-1.576",
  "navigation-components": "static-1.18916",
  "breeze-engine-lib": "static-1.1861",
  "simple-logging-lib": "static-1.3398",
  "nudge-client-utils": "static-1.3213",
  "fail-safe": "static-1.303",
  "app-governance-lib": "static-1.2472",
  "developer-experience-shared-components": "static-1.10885",
  "purchase-motions-components": "static-1.6449",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10403",
  "usage-tracker-anonymous": "static-1.6078",
  "usage-tracker-public": "static-1.7472",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4050",
  "reference-resolvers": "static-1.8529",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4265",
  "hubspot-apollo-cache": "static-1.683",
  "universal-page-editor-lib": "static-1.3358",
  "final-form": "static-1.79",
  "redux-toolkit": "static-1.79",
  "simple-data-table": "static-1.3596",
  "merchandise-lib": "static-1.279",
  "ui-addon-draggable": "static-3.5104",
  "content-assistance-lib": "static-1.8261",
  "content-media-capture": "static-1.5531",
  "customer-data-ui-utilities": "static-1.10179",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24602",
  "growth-payments-core": "static-1.26273",
  "knowledge-content-types": "static-1.8692",
  "PatternValidationJS": "static-1.3239",
  "payment-link-components": "static-1.24230",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20372",
  "ui-addon-emoji-picker": "static-1.10231",
  "ui-business-units-lib": "static-1.9439",
  "video-components-external": "static-1.12227",
  "video-data-lib": "static-1.35885",
  "navigation-messaging": "static-1.8243",
  "collaboration-sidebar": "static-1.58810",
  "crm-component-utils": "static-1.39931",
  "crm-properties-common-lib": "static-1.6238",
  "customer-data-properties": "static-1.52718",
  "external-options-client-types": "static-1.4372",
  "framework-data-schema-resolvers": "static-1.7242",
  "property-value-citations": "static-1.3332",
  "reference-resolvers-lite": "static-1.8451",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.53",
  "hubspotter-http-shared-msw-handlers": "static-1.10694",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "tanstack-virtual": "static-1.39",
  "cms-field-types": "static-1.5160",
  "content-icons-ui": "static-1.2410",
  "atom": "static-1.5430",
  "idb-keyval": "static-1.52",
  "reactive-lib": "static-1.1066",
  "breeze-artifacts-sdk": "static-1.495",
  "getting-started-shared-tasks": "static-1.19334",
  "onboarding-journeys-lib": "static-1.1023",
  "onboarding-scopes": "static-1.6800",
  "conversations-skeleton-state": "static-1.7594",
  "crm-message-bus": "static-1.43858",
  "customer-data-filters-ui-msw-helpers": "static-1.23485",
  "events-data-lib": "static-1.596",
  "FormUrlGenerator": "static-2.5073",
  "framework-builder-read-service-client": "static-1.4253",
  "hs-resources": "static-1.541",
  "multi-account-reference-resolvers": "static-1.1355",
  "onboarding-tours": "static-1.17200",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14546",
  "segments-client-types": "static-1.11704",
  "academy-common-lib": "static-1.15126",
  "dashboard-lib": "static-1.82976",
  "hubspot-prosemirror-plugins": "static-1.19056",
  "share-with-third-party-component-lib": "static-1.9057",
  "ui-asset-management-lib": "static-1.11449",
  "user-context": "static-1.5468",
  "reporting-plugins": "static-1.10822",
  "reporting-reports": "static-1.68634",
  "hubs-service-types": "static-1.1608",
  "purchase-motions-api": "static-1.6452",
  "salesImages": "static-1.608",
  "signup-constants": "static-1.19701",
  "nest": "static-1.585",
  "breeze-engine-chat-components": "static-1.839",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.2970",
  "nudge-renderer-utils": "static-1.3289",
  "whisper-core-api": "static-1.7411",
  "bend-plugin-fail-safe": "static-1.254",
  "framework-listing-lib": "static-2.29586",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31505",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4581",
  "signup-ui-url-generator": "static-2.8408",
  "onboarding-tours-client": "static-1.5415",
  "one-click-checkout": "static-1.508",
  "platform-infra-nav-components": "static-1.7925",
  "subscription-experience-data-types": "static-1.15287",
  "crm-record-cards-service-types": "static-1.3798",
  "location-customization-utils-lib": "static-1.10191",
  "redux-thunk": "static-2.81",
  "react-flip-move": "static-1.79",
  "ui-coaching-tips": "static-1.29391",
  "content-media-composition-data-lib": "static-1.13335",
  "fix-webm-duration": "static-1.31",
  "notification-sounds": "static-1.4773",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.799",
  "ui-addon-opt": "static-4.8713",
  "commerce-tours-lib": "static-1.6686",
  "growth-onboarding-reliability": "static-1.5429",
  "sales-checkout-service-client": "static-1.3877",
  "data-token-picker": "static-1.16950",
  "FileManagerLib": "static-1.40242",
  "content-media-compositions": "static-2.17342",
  "media-bridge-lib": "static-1.19468",
  "chatspot-widget-iframe": "static-1.23224",
  "collaboration-sidebar-common": "static-1.3607",
  "marketing-platform-lib": "static-1.7222",
  "card-properties-lib": "static-1.45097",
  "commerce-subscription-lib": "static-1.37870",
  "crm-actions": "static-1.6698",
  "crm-cards-sdk": "static-1.44689",
  "customer-data-properties-shared-msw-handlers": "static-1.10023",
  "customer-data-tracking": "static-1.7229",
  "calling-global-api": "static-1.65764",
  "calling-internal-common": "static-1.31670",
  "calling-lifecycle-internal": "static-1.67146",
  "calling-lifecycle-messages": "static-1.59440",
  "commerce-products-lib": "static-1.10635",
  "conditional-properties-service-client": "static-1.4048",
  "crm-index-visualization-core": "static-1.4594",
  "crm-links": "static-1.6658",
  "crm-pipelines-api-client-types": "static-1.4379",
  "formula-editor": "static-1.14833",
  "google-libphonenumber": "static-1.46",
  "inbounddb-objects-service-types": "static-1.4457",
  "meetings-icalendar-utils-lib": "static-1.983",
  "multi-currency-client-types": "static-1.3939",
  "object-builder-ui-client": "static-1.49783",
  "pipeline-validation-client-types": "static-1.4214",
  "smart-data-capture-core": "static-1.213",
  "smart-property-lib": "static-1.8393",
  "tiered-pricing": "static-1.2030",
  "topics-actions-lib": "static-1.518",
  "ui-addon-form-validation": "static-1.11331",
  "zustand": "static-1.86",
  "fdsr-migration-layer": "static-1.361",
  "framework-data-schema-quick-fetch": "static-1.7147",
  "restore-request-side-panel-lib": "static-1.1760",
  "growth-data-modal": "static-1.5957",
  "growth-onboarding-confetti": "static-1.3413",
  "growth-onboarding-next-action-utils": "static-1.2771",
  "onboarding-tours-utils": "static-1.1267",
  "ui-shepherd-tracker": "static-1.8000",
  "crm-index-associations-lib": "static-1.6793",
  "academy-service-client": "static-1.4040",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40101",
  "SafeStorage": "static-1.4753",
  "video-embed": "static-1.36719",
  "redux-actions": "static-3.71",
  "EmailSignatureEditor": "static-1.25071",
  "viral-links-lib": "static-1.7424",
  "nested-table": "static-1.583",
  "timezone-utils": "static-2.5590",
  "getting-started-shared-tasks-store": "static-1.18452",
  "campaign-roi-lib": "static-1.10459",
  "campaigns-utils-lib": "static-1.3575",
  "ui-addon-calendars": "static-2.5693",
  "customer-data-views-management": "static-1.26111",
  "framework-data-table": "static-2.12630",
  "nudge-custom-ui-functions": "static-1.1564",
  "switchboard-lib": "static-1.569",
  "access-check-ui-lib": "static-1.1673",
  "app-users-service-client": "static-1.5968",
  "app-users-service-types": "static-1.5376",
  "mini-checkout-client": "static-1.27603",
  "onboarding-utils": "static-1.5719",
  "permissions-shared-i18n-strings-fe": "static-1.2123",
  "ui-coaching-tips-shared-config": "static-1.29376",
  "checkout-sdk": "static-3.24446",
  "payment-method-components": "static-1.7194",
  "touchless-buying-components": "static-1.6314",
  "upgrade-catalog-service-types": "static-1.3796",
  "edison-service-client-types": "static-1.743",
  "growth-onboarding-feedback-components": "static-1.6933",
  "audio-components": "static-1.6408",
  "FileManagerImages": "static-1.37753",
  "video-components": "static-1.14229",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92937",
  "customer-data-sidebar": "static-2.46815",
  "enrichment-lib": "static-1.570",
  "ui-addon-draggable-compat": "static-2.4611",
  "universal-record-utils-lib": "static-1.2090",
  "commerce-billing-lib": "static-1.20300",
  "commerce-shared-components-lib": "static-1.19333",
  "commerce-tools-ui-lib": "static-1.11124",
  "crm-fe-perf": "static-1.23246",
  "calling-error-reporting": "static-1.31677",
  "shared-worker-versioning": "static-1.11389",
  "calling-usage-tracker": "static-1.6884",
  "voice-sms-access-library": "static-1.2155",
  "commerce-permissions": "static-1.1125",
  "products-iframe-lib": "static-1.8667",
  "products-ui-components-shared-msw-handlers": "static-1.11078",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10779",
  "sales-views-client-types": "static-1.4604",
  "bark-lib": "static-1.16864",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.715",
  "policy-lib": "static-1.7154",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10842",
  "onboarding-data-sync-lib": "static-1.2585",
  "growth-onboarding-next-action-components": "static-1.2799",
  "user-context-client": "static-1.4857",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.62",
  "urlinator": "static-1.4877",
  "outpost": "static-1.4499",
  "draft-convert": "static-2.81",
  "draft-extend": "static-3.84",
  "draft-js": "static-5.86",
  "draft-plugins": "static-2.22219",
  "sales-email-signature-service-client": "static-1.4195",
  "ts-utils-lib": "static-1.496",
  "copilot-messaging": "static-1.2176",
  "crm-export-dialog": "static-1.6632",
  "crm-index-ui-shimmer": "static-1.2756",
  "crm-view-components": "static-1.1276",
  "react-beautiful-dnd": "static-1.71",
  "customer-data-associations": "static-1.7678",
  "tasks-actions-lib": "static-1.222",
  "InboxConnectUtils": "static-4.15638",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46928",
  "hub-http-rxjs": "static-1.855",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4339",
  "company-details-components": "static-1.6554",
  "react-performance-metrics-lib": "static-1.901",
  "pricing-pages-ui-components": "static-1.15996",
  "quote-checkout-service-types": "static-1.3802",
  "social-insights-client-types": "static-1.22721",
  "crm_universal": "static-1.22554",
  "customer-data-email": "static-1.18582",
  "card-payment-highlight-lib": "static-1.38083",
  "commerce-contract-lib": "static-1.13480",
  "invoices-highlight-card-lib": "static-1.55872",
  "orders-highlight-card-lib": "static-1.22276",
  "products-highlight-card-lib": "static-1.18918",
  "quotes-highlight-card-lib": "static-1.72860",
  "crm-source-interpretation-lib": "static-1.5679",
  "data-agent-utils": "static-1.632",
  "crm-object-search-query-utilities": "static-1.10266",
  "utility-belt": "static-1.2881",
  "payments-enrollment-embed-lib": "static-1.23926",
  "stripe-embedded-components": "static-1.8058",
  "customer-data-rte": "static-1.33718",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6347",
  "payments-post-enroll-local-storage-lib": "static-1.5452",
  "qrcode-generator": "static-1.77",
  "quotes-client-types": "static-1.38950",
  "calling-orchestration-schema": "static-1.36932",
  "react-reducer-toolkit": "static-1.16445",
  "meetings-connect-utils-lib": "static-1.7959",
  "hub-http-contrib": "static-1.3387",
  "ui-addon-sales-email": "static-1.5561",
  "access-control-lib": "static-1.10784",
  "EmailComponents": "static-1.55633",
  "EmailData": "static-1.54311",
  "redux-less": "static-2.9822",
  "company-details-service-types": "static-1.4291",
  "segments-query-core": "static-1.1773",
  "pricing-pages-api": "static-1.15861",
  "sequences-lib": "static-1.8593",
  "ui-gdpr-components": "static-1.10643",
  "products-ui-components": "static-1.41153",
  "accounting-integrations-ui-components": "static-1.7600",
  "invoices-ui-lib": "static-1.55888",
  "commerce-products-api": "static-1.2742",
  "invoices-iframe-lib": "static-1.57946",
  "quotes-modal-lib": "static-1.103538",
  "quotes-ui-lib": "static-1.81581",
  "stripe-connect-js": "static-1.78",
  "draft-content-plugins": "static-1.28977",
  "ContentComponents": "static-2.72170",
  "ContentData": "static-1.69289",
  "marketing-email-service-types": "static-1.2123",
  "messaging-editing-lib": "static-1.47242",
  "messaging-usage-based-billing-components-lib": "static-1.2104",
  "automation-ui-source-apps": "static-1.19767",
  "automation-ui-types": "static-1.20685",
  "messaging-types-lib": "static-1.46979",
  "onboarding-settings-client": "static-1.4857",
  "sequences-client-types-lib": "static-1.8450",
  "commerce-tax-lib": "static-1.888",
  "price-books-api": "static-1.1810",
  "price-books-components": "static-1.1868",
  "property-description-translator": "static-1.4183",
  "ramp-editor": "static-1.964",
  "commerce-analytics-service-client": "static-1.3865",
  "totals-ui-components": "static-1.24368",
  "SalesContentIndexUI": "static-3.9674",
  "advanced-menus-core": "static-1.15638",
  "advanced-menus-lib": "static-1.12505",
  "automation-ui-ubb": "static-1.6601",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7685",
  "data-token-views": "static-1.16931",
  "forms-utils-lib": "static-1.13152",
  "payments-embed-points-lib": "static-1.13658",
  "react-tinymce": "static-1.56060",
  "simple-menus-core": "static-1.15637",
  "simple-menus-lib": "static-1.17154",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55186",
  "tinymce-data": "static-1.41271",
  "tinymce-plugins": "static-1.58300",
  "tinymce-themes": "static-1.57156",
  "ui-brand-identity-lib": "static-1.16651",
  "ui-memberships-settings-lib": "static-1.34925",
  "videoconference-integration-components": "static-1.7354",
  "automation-applications-service-types": "static-1.3664",
  "automation-platform-service-types": "static-1.2675",
  "ContentEditorUI": "static-2.78001",
  "content-whatsapp-service-types": "static-1.579",
  "short-messages-app-service-client": "static-1.4268",
  "web-interactives-components": "static-1.14308",
  "web-interactives-data": "static-1.14309",
  "messaging-shared-utils-lib": "static-1.1553",
  "messaging-user-info-utils-lib": "static-1.1723",
  "email-portal-health-service-types": "static-1.1330",
  "line-items-api": "static-1.1151",
  "commerce-totals-service-types": "static-1.4064",
  "FireAlarmUi": "static-1.4756",
  "sales-templates-service-types-lib": "static-1.4416",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22621",
  "automation-ui-usage-tracking": "static-1.22084",
  "data-studio-ubb": "static-1.3590",
  "interframe": "static-3.5102",
  "layout-dnd-components": "static-1.13034",
  "layout-dnd-utils": "static-1.12009",
  "NamespacedHubStyle": "static-2.9294",
  "campaigns-lib": "static-1.27730",
  "content-management-data-lib": "static-1.6032",
  "copilot-plugins": "static-1.11898",
  "cta-picker": "static-1.37159",
  "customer-agent-discovery-components-lib": "static-1.4038",
  "editor-components": "static-1.13711",
  "editor-iframe-lib": "static-1.8855",
  "error-messaging-js": "static-1.5546",
  "FormsCommonComponents": "static-1.86653",
  "layout-data-lib": "static-1.10334",
  "pictos": "static-7.191",
  "react-transition-group": "static-2.74",
  "redux-request-state": "static-1.10994",
  "SharedLegalStrings": "static-1.2088",
  "smart-content-core": "static-1.43253",
  "smart-content-lib": "static-1.43906",
  "social-composer-lib": "static-1.60369",
  "structured-content-lib": "static-1.25995",
  "theme-previewer-lib": "static-1.53987",
  "tinymce-copilot": "static-1.17254",
  "xray-recommendation-lib": "static-1.8315",
  "automation-ui-routing": "static-1.22042",
  "sql-reporting-client-types": "static-1.5929",
  "attribution-lib": "static-1.42863",
  "reporting-enablement": "static-1.23914",
  "voice-agents-components": "static-1.3871",
  "forms-ai-lib": "static-1.4822",
  "codemirror-dlb": "static-1.59560",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6790",
  "report-customization-components": "static-1.13987",
  "data-quality-ui-library": "static-1.13963",
  "reporting-filters": "static-1.1074",
  "reporting-insights-lib": "static-1.2666",
  "calling-orchestration-shared-library": "static-1.36707",
  "merge-modal-lib": "static-1.12719"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13315",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.890",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.9999",
  "foundations-components": "/foundations-components/static-1.8562",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1587",
  "foundations-theming": "/foundations-theming/static-1.4825",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.90",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8384",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10696",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyleTokens": "/HubStyleTokens/static-2.11839",
  "I18n": "/I18n/static-7.1680",
  "jasmine-runner": "/jasmine-runner/static-1.6798",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.711",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13378",
  "quartz": "/quartz/static-1.7513",
  "react-dlb": "/react-dlb/static-1.89",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-rhumb-pageload-totimings.2",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3202",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10891",
  "reselect": "/reselect/static-3.13",
  "settings-ui-lib": "/settings-ui-lib/static-1.12872",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7688",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11495",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9881",
  "unified-auth": "/unified-auth/static-1.1000",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1282",
  "usage-tracker": "/usage-tracker/static-1.7661",
  "usage-tracker-core": "/usage-tracker-core/static-1.7511",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8445",
  "hub-http": "/hub-http/static-1.6560",
  "integrations-lib": "/integrations-lib/static-1.17159",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20821",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.807",
  "property-management-iframe": "/property-management-iframe/static-1.14220",
  "quartz-config": "/quartz-config/static-1.1291",
  "quartz-core": "/quartz-core/static-1.6732",
  "quartz-routing": "/quartz-routing/static-1.943",
  "quick-fetch": "/quick-fetch/static-1.4159",
  "react": "/react/static-7.196",
  "rpc-client-utils": "/rpc-client-utils/static-1.5014",
  "ts-schema": "/ts-schema/static-1.4325",
  "ui-universal-auth": "/ui-universal-auth/static-1.9486",
  "UIComponents": "/UIComponents/static-3.8785",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.87",
  "metrics-js": "/metrics-js/static-1.9963",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3790",
  "quartz-webpack": "/quartz-webpack/static-1.3737",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.591",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9809",
  "codemirror": "/codemirror/static-5.103",
  "foundations-assets": "/foundations-assets/static-1.5234",
  "pulse": "/pulse/static-1.978",
  "react-codemirror": "/react-codemirror/static-1.10991",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.695",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4831",
  "floating-ui": "/floating-ui/static-1.64",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2541",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-story-utils": "/hs-story-utils/static-1.9772",
  "react-aria": "/react-aria/static-1.73",
  "react-create-root-preference": "/react-create-root-preference/static-1.79",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5587",
  "react-virtualized": "/react-virtualized/static-2.108",
  "StyleGuideUI": "/StyleGuideUI/static-3.508",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2752",
  "ui-fonts": "/ui-fonts/static-1.1101",
  "ui-images": "/ui-images/static-2.1265",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3308",
  "foundations-theming-base": "/foundations-theming-base/static-1.3810",
  "stylex": "/stylex/static-1.42",
  "HeadJS": "/HeadJS/static-2.804",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3495",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.159",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4660",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9049",
  "ai-rendering-library": "/ai-rendering-library/static-1.11187",
  "chirp-fetch": "/chirp-fetch/static-1.2245",
  "connections-embed-lib": "/connections-embed-lib/static-1.1575",
  "copilot-toolkit": "/copilot-toolkit/static-1.11926",
  "feedback-loader": "/feedback-loader/static-1.29874",
  "laboratory-lib": "/laboratory-lib/static-3.7501",
  "marketplace-embed": "/marketplace-embed/static-1.22999",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10716",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20776",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14991",
  "sanitize-text": "/sanitize-text/static-1.8505",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6075",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5347",
  "wootric-nps": "/wootric-nps/static-1.7232",
  "quartz-head": "/quartz-head/static-1.1178",
  "web-vitals": "/web-vitals/static-1.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5004",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4493",
  "highcharts": "/highcharts/static-8.112",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2720",
  "reporting-data": "/reporting-data/static-1.68958",
  "cssUtils": "/cssUtils/static-1.971",
  "flux-actions": "/flux-actions/static-1.374",
  "react-colorpicker": "/react-colorpicker/static-2.10562",
  "react-dnd-compat": "/react-dnd-compat/static-1.4964",
  "redux-observable": "/redux-observable/static-1.76",
  "ReduxMessenger": "/ReduxMessenger/static-2.10719",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7651",
  "icons": "/icons/static-2.695",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19353",
  "storybook-react": "/storybook-react/static-1.41",
  "trellis-story-utils": "/trellis-story-utils/static-1.4855",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6045",
  "quartz-i18n": "/quartz-i18n/static-1.1188",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.549",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1526",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.50",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1113",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.240",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.582",
  "slack-ui-library": "/slack-ui-library/static-1.10746",
  "fsm": "/fsm/static-1.4100",
  "customer-data-objects": "/customer-data-objects/static-1.8047",
  "property-translator": "/property-translator/static-1.5740",
  "hs-locale-management": "/hs-locale-management/static-1.326",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8267",
  "hs-promise-utils": "/hs-promise-utils/static-1.5938",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5224",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14575",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5958",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8124",
  "sanitize": "/sanitize/static-1.4820",
  "superstore": "/superstore/static-1.5108",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10619",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8406",
  "hub-http-janus": "/hub-http-janus/static-1.888",
  "hubspotter-http": "/hubspotter-http/static-1.4895",
  "immutable-less": "/immutable-less/static-1.4999",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18228",
  "nav-meta": "/nav-meta/static-1.30553",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18439",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1202",
  "ai-studio-lib": "/ai-studio-lib/static-1.12511",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19064",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.548",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9425",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8374",
  "ui-product-approvals": "/ui-product-approvals/static-1.29307",
  "ui-tool-access": "/ui-tool-access/static-1.10503",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4079",
  "property-management-common": "/property-management-common/static-1.6508",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.126",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.584",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.501",
  "quartz-auth": "/quartz-auth/static-1.1188",
  "quartz-test": "/quartz-test/static-1.1188",
  "quartz-tracking": "/quartz-tracking/static-1.892",
  "trellis-components": "/trellis-components/static-1.2771",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.424",
  "HubStyle": "/HubStyle/static-2.12146",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23233",
  "ContentUtils": "/ContentUtils/static-1.69213",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13379",
  "sassPrefix": "/sassPrefix/static-1.237",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.481",
  "batch-promise": "/batch-promise/static-1.1893",
  "event-emitter": "/event-emitter/static-1.1305",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5789",
  "magpie-types": "/magpie-types/static-1.5249",
  "stylex-utils": "/stylex-utils/static-1.148",
  "trellis-theming": "/trellis-theming/static-1.1322",
  "avatar-components": "/avatar-components/static-1.2832",
  "breeze-engine-core": "/breeze-engine-core/static-1.1139",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.819",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41050",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13526",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15666",
  "ExportDialog": "/ExportDialog/static-6.10727",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.232",
  "highlight.js": "/highlight.js/static-1.87",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.702",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42147",
  "reporting-snowflake": "/reporting-snowflake/static-1.57574",
  "reporting-ui-components": "/reporting-ui-components/static-2.66227",
  "reporting-visualizations": "/reporting-visualizations/static-1.61032",
  "trial-components-library": "/trial-components-library/static-1.14182",
  "ui-addon-teams": "/ui-addon-teams/static-1.21959",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.576",
  "navigation-components": "/navigation-components/static-1.18916",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1861",
  "simple-logging-lib": "/simple-logging-lib/static-1.3398",
  "nudge-client-utils": "/nudge-client-utils/static-1.3213",
  "fail-safe": "/fail-safe/static-1.303",
  "app-governance-lib": "/app-governance-lib/static-1.2472",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10885",
  "purchase-motions-components": "/purchase-motions-components/static-1.6449",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10403",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6078",
  "usage-tracker-public": "/usage-tracker-public/static-1.7472",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4050",
  "reference-resolvers": "/reference-resolvers/static-1.8529",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4265",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.683",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3358",
  "final-form": "/final-form/static-1.79",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "simple-data-table": "/simple-data-table/static-1.3596",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5104",
  "content-assistance-lib": "/content-assistance-lib/static-1.8261",
  "content-media-capture": "/content-media-capture/static-1.5531",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10179",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24602",
  "growth-payments-core": "/growth-payments-core/static-1.26273",
  "knowledge-content-types": "/knowledge-content-types/static-1.8692",
  "PatternValidationJS": "/PatternValidationJS/static-1.3239",
  "payment-link-components": "/payment-link-components/static-1.24230",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20372",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10231",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9439",
  "video-components-external": "/video-components-external/static-1.12227",
  "video-data-lib": "/video-data-lib/static-1.35885",
  "navigation-messaging": "/navigation-messaging/static-1.8243",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58810",
  "crm-component-utils": "/crm-component-utils/static-1.39931",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6238",
  "customer-data-properties": "/customer-data-properties/static-1.52718",
  "external-options-client-types": "/external-options-client-types/static-1.4372",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7242",
  "property-value-citations": "/property-value-citations/static-1.3332",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8451",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.53",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10694",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "cms-field-types": "/cms-field-types/static-1.5160",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "atom": "/atom/static-1.5430",
  "idb-keyval": "/idb-keyval/static-1.52",
  "reactive-lib": "/reactive-lib/static-1.1066",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.495",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19334",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1023",
  "onboarding-scopes": "/onboarding-scopes/static-1.6800",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7594",
  "crm-message-bus": "/crm-message-bus/static-1.43858",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23485",
  "events-data-lib": "/events-data-lib/static-1.596",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5073",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4253",
  "hs-resources": "/hs-resources/static-1.541",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1355",
  "onboarding-tours": "/onboarding-tours/static-1.17200",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14546",
  "segments-client-types": "/segments-client-types/static-1.11704",
  "academy-common-lib": "/academy-common-lib/static-1.15126",
  "dashboard-lib": "/dashboard-lib/static-1.82976",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19056",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9057",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11449",
  "user-context": "/user-context/static-1.5468",
  "reporting-plugins": "/reporting-plugins/static-1.10822",
  "reporting-reports": "/reporting-reports/static-1.68634",
  "hubs-service-types": "/hubs-service-types/static-1.1608",
  "purchase-motions-api": "/purchase-motions-api/static-1.6452",
  "salesImages": "/salesImages/static-1.608",
  "signup-constants": "/signup-constants/static-1.19701",
  "nest": "/nest/static-1.585",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.839",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2970",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3289",
  "whisper-core-api": "/whisper-core-api/static-1.7411",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.254",
  "framework-listing-lib": "/framework-listing-lib/static-2.29586",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31505",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4581",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8408",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5415",
  "one-click-checkout": "/one-click-checkout/static-1.508",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7925",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15287",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3798",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10191",
  "redux-thunk": "/redux-thunk/static-2.81",
  "react-flip-move": "/react-flip-move/static-1.79",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29391",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13335",
  "fix-webm-duration": "/fix-webm-duration/static-1.31",
  "notification-sounds": "/notification-sounds/static-1.4773",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.799",
  "ui-addon-opt": "/ui-addon-opt/static-4.8713",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6686",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5429",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3877",
  "data-token-picker": "/data-token-picker/static-1.16950",
  "FileManagerLib": "/FileManagerLib/static-1.40242",
  "content-media-compositions": "/content-media-compositions/static-2.17342",
  "media-bridge-lib": "/media-bridge-lib/static-1.19468",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23224",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3607",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7222",
  "card-properties-lib": "/card-properties-lib/static-1.45097",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37870",
  "crm-actions": "/crm-actions/static-1.6698",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44689",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10023",
  "customer-data-tracking": "/customer-data-tracking/static-1.7229",
  "calling-global-api": "/calling-global-api/static-1.65764",
  "calling-internal-common": "/calling-internal-common/static-1.31670",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67146",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59440",
  "commerce-products-lib": "/commerce-products-lib/static-1.10635",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4048",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4594",
  "crm-links": "/crm-links/static-1.6658",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4379",
  "formula-editor": "/formula-editor/static-1.14833",
  "google-libphonenumber": "/google-libphonenumber/static-1.46",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4457",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.983",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3939",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49783",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4214",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.213",
  "smart-property-lib": "/smart-property-lib/static-1.8393",
  "tiered-pricing": "/tiered-pricing/static-1.2030",
  "topics-actions-lib": "/topics-actions-lib/static-1.518",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11331",
  "zustand": "/zustand/static-1.86",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.361",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7147",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1760",
  "growth-data-modal": "/growth-data-modal/static-1.5957",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3413",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2771",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1267",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8000",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6793",
  "academy-service-client": "/academy-service-client/static-1.4040",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40101",
  "SafeStorage": "/SafeStorage/static-1.4753",
  "video-embed": "/video-embed/static-1.36719",
  "redux-actions": "/redux-actions/static-3.71",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25071",
  "viral-links-lib": "/viral-links-lib/static-1.7424",
  "nested-table": "/nested-table/static-1.583",
  "timezone-utils": "/timezone-utils/static-2.5590",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18452",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10459",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3575",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5693",
  "customer-data-views-management": "/customer-data-views-management/static-1.26111",
  "framework-data-table": "/framework-data-table/static-2.12630",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1564",
  "switchboard-lib": "/switchboard-lib/static-1.569",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1673",
  "app-users-service-client": "/app-users-service-client/static-1.5968",
  "app-users-service-types": "/app-users-service-types/static-1.5376",
  "mini-checkout-client": "/mini-checkout-client/static-1.27603",
  "onboarding-utils": "/onboarding-utils/static-1.5719",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2123",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29376",
  "checkout-sdk": "/checkout-sdk/static-3.24446",
  "payment-method-components": "/payment-method-components/static-1.7194",
  "touchless-buying-components": "/touchless-buying-components/static-1.6314",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
  "edison-service-client-types": "/edison-service-client-types/static-1.743",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6933",
  "audio-components": "/audio-components/static-1.6408",
  "FileManagerImages": "/FileManagerImages/static-1.37753",
  "video-components": "/video-components/static-1.14229",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92937",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46815",
  "enrichment-lib": "/enrichment-lib/static-1.570",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4611",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2090",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20300",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19333",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11124",
  "crm-fe-perf": "/crm-fe-perf/static-1.23246",
  "calling-error-reporting": "/calling-error-reporting/static-1.31677",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11389",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6884",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2155",
  "commerce-permissions": "/commerce-permissions/static-1.1125",
  "products-iframe-lib": "/products-iframe-lib/static-1.8667",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11078",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10779",
  "sales-views-client-types": "/sales-views-client-types/static-1.4604",
  "bark-lib": "/bark-lib/static-1.16864",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.715",
  "policy-lib": "/policy-lib/static-1.7154",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10842",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2585",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2799",
  "user-context-client": "/user-context-client/static-1.4857",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.62",
  "urlinator": "/urlinator/static-1.4877",
  "outpost": "/outpost/static-1.4499",
  "draft-convert": "/draft-convert/static-2.81",
  "draft-extend": "/draft-extend/static-3.84",
  "draft-js": "/draft-js/static-5.86",
  "draft-plugins": "/draft-plugins/static-2.22219",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4195",
  "ts-utils-lib": "/ts-utils-lib/static-1.496",
  "copilot-messaging": "/copilot-messaging/static-1.2176",
  "crm-export-dialog": "/crm-export-dialog/static-1.6632",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2756",
  "crm-view-components": "/crm-view-components/static-1.1276",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.71",
  "customer-data-associations": "/customer-data-associations/static-1.7678",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.222",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15638",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46928",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.855",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4339",
  "company-details-components": "/company-details-components/static-1.6554",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.901",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15996",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3802",
  "social-insights-client-types": "/social-insights-client-types/static-1.22721",
  "crm_universal": "/crm_universal/static-1.22554",
  "customer-data-email": "/customer-data-email/static-1.18582",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38083",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13480",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55872",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22276",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18918",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72860",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5679",
  "data-agent-utils": "/data-agent-utils/static-1.632",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10266",
  "utility-belt": "/utility-belt/static-1.2881",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23926",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8058",
  "customer-data-rte": "/customer-data-rte/static-1.33718",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6347",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5452",
  "qrcode-generator": "/qrcode-generator/static-1.77",
  "quotes-client-types": "/quotes-client-types/static-1.38950",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36932",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16445",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7959",
  "hub-http-contrib": "/hub-http-contrib/static-1.3387",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5561",
  "access-control-lib": "/access-control-lib/static-1.10784",
  "EmailComponents": "/EmailComponents/static-1.55633",
  "EmailData": "/EmailData/static-1.54311",
  "redux-less": "/redux-less/static-2.9822",
  "company-details-service-types": "/company-details-service-types/static-1.4291",
  "segments-query-core": "/segments-query-core/static-1.1773",
  "pricing-pages-api": "/pricing-pages-api/static-1.15861",
  "sequences-lib": "/sequences-lib/static-1.8593",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10643",
  "products-ui-components": "/products-ui-components/static-1.41153",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7600",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55888",
  "commerce-products-api": "/commerce-products-api/static-1.2742",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57946",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103538",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81581",
  "stripe-connect-js": "/stripe-connect-js/static-1.78",
  "draft-content-plugins": "/draft-content-plugins/static-1.28977",
  "ContentComponents": "/ContentComponents/static-2.72170",
  "ContentData": "/ContentData/static-1.69289",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2123",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47242",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2104",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19767",
  "automation-ui-types": "/automation-ui-types/static-1.20685",
  "messaging-types-lib": "/messaging-types-lib/static-1.46979",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4857",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8450",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.888",
  "price-books-api": "/price-books-api/static-1.1810",
  "price-books-components": "/price-books-components/static-1.1868",
  "property-description-translator": "/property-description-translator/static-1.4183",
  "ramp-editor": "/ramp-editor/static-1.964",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3865",
  "totals-ui-components": "/totals-ui-components/static-1.24368",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9674",
  "advanced-menus-core": "/advanced-menus-core/static-1.15638",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12505",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6601",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7685",
  "data-token-views": "/data-token-views/static-1.16931",
  "forms-utils-lib": "/forms-utils-lib/static-1.13152",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13658",
  "react-tinymce": "/react-tinymce/static-1.56060",
  "simple-menus-core": "/simple-menus-core/static-1.15637",
  "simple-menus-lib": "/simple-menus-lib/static-1.17154",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55186",
  "tinymce-data": "/tinymce-data/static-1.41271",
  "tinymce-plugins": "/tinymce-plugins/static-1.58300",
  "tinymce-themes": "/tinymce-themes/static-1.57156",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16651",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34925",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7354",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3664",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2675",
  "ContentEditorUI": "/ContentEditorUI/static-2.78001",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.579",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4268",
  "web-interactives-components": "/web-interactives-components/static-1.14308",
  "web-interactives-data": "/web-interactives-data/static-1.14309",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1553",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1723",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1330",
  "line-items-api": "/line-items-api/static-1.1151",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4064",
  "FireAlarmUi": "/FireAlarmUi/static-1.4756",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4416",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22621",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22084",
  "data-studio-ubb": "/data-studio-ubb/static-1.3590",
  "interframe": "/interframe/static-3.5102",
  "layout-dnd-components": "/layout-dnd-components/static-1.13034",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12009",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9294",
  "campaigns-lib": "/campaigns-lib/static-1.27730",
  "content-management-data-lib": "/content-management-data-lib/static-1.6032",
  "copilot-plugins": "/copilot-plugins/static-1.11898",
  "cta-picker": "/cta-picker/static-1.37159",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4038",
  "editor-components": "/editor-components/static-1.13711",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8855",
  "error-messaging-js": "/error-messaging-js/static-1.5546",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86653",
  "layout-data-lib": "/layout-data-lib/static-1.10334",
  "pictos": "/pictos/static-7.191",
  "react-transition-group": "/react-transition-group/static-2.74",
  "redux-request-state": "/redux-request-state/static-1.10994",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2088",
  "smart-content-core": "/smart-content-core/static-1.43253",
  "smart-content-lib": "/smart-content-lib/static-1.43906",
  "social-composer-lib": "/social-composer-lib/static-1.60369",
  "structured-content-lib": "/structured-content-lib/static-1.25995",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53987",
  "tinymce-copilot": "/tinymce-copilot/static-1.17254",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8315",
  "automation-ui-routing": "/automation-ui-routing/static-1.22042",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5929",
  "attribution-lib": "/attribution-lib/static-1.42863",
  "reporting-enablement": "/reporting-enablement/static-1.23914",
  "voice-agents-components": "/voice-agents-components/static-1.3871",
  "forms-ai-lib": "/forms-ai-lib/static-1.4822",
  "codemirror-dlb": "/codemirror-dlb/static-1.59560",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6790",
  "report-customization-components": "/report-customization-components/static-1.13987",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13963",
  "reporting-filters": "/reporting-filters/static-1.1074",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2666",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36707",
  "merge-modal-lib": "/merge-modal-lib/static-1.12719"
}
};
